import { render, staticRenderFns } from "./CopiableText.vue?vue&type=template&id=99de3f02&scoped=true"
import script from "./CopiableText.vue?vue&type=script&lang=js"
export * from "./CopiableText.vue?vue&type=script&lang=js"
import style0 from "./CopiableText.vue?vue&type=style&index=0&id=99de3f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99de3f02",
  null
  
)

export default component.exports